<template>
  <div class="search-bank-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-search"></i> Search Result</span>
      </div>

        <div class="btn-status">
          <el-badge :value="count.all" :max="99" class="item" type="primary">
            <el-button type="primary" size="small" :plain="btnActive.all" @click="getDataSelect()">All</el-button>
          </el-badge>
          <el-badge :value="count.active" :max="99" class="item" type="success">
            <el-button type="success" size="small" :plain="btnActive.active" @click="getDataSelect('active')">Active</el-button>
          </el-badge>
          <el-badge :value="count.suspended" :max="99" class="item" type="info">
            <el-button type="info" size="small" :plain="btnActive.suspended" @click="getDataSelect('suspended')">Suspended</el-button>
          </el-badge>
          <el-badge :value="count.closed" :max="99" class="item" type="danger">
            <el-button type="danger" size="small" :plain="btnActive.closed" @click="getDataSelect('closed')">Closed</el-button>
          </el-badge>
        </div>

        <el-table
          v-loading="loading"
          :data="dataTableSelect"
          border
          style="width: 100%">
          <el-table-column prop="bankholderID" label="BankholderID" header-align="center" align="center" width="120" fixed></el-table-column>
          <el-table-column prop="member_code" label="Member code" header-align="center" align="center" width="100" fixed></el-table-column>
          <el-table-column prop="name" label="Name" header-align="center" align="center" width="220">
            <template slot-scope="scope">
              {{ bankAccountName(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="currency" label="Currency" header-align="center" align="center" >
            <template slot-scope="scope">
              {{ scope.row.currency && scope.row.currency.toUpperCase() }}
            </template>
          </el-table-column>
          <el-table-column prop="account_type" label="Account Type" header-align="center" align="center" width="170">
            <template slot-scope="scope">
              <el-tag :type="isCashAccount(scope.row) ? 'warning' : 'info'" size="small">{{ accountTypeLabel(scope.row) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="referenceID" label="Ref" header-align="center" align="center" width="150"></el-table-column>
          <!-- cash account (wallet) has no account number / sort code -->
          <el-table-column prop="accountnumber" label="Account Number" header-align="center" align="center" width="120">
            <template slot-scope="scope">
              {{ isCashAccount(scope.row) ? "" : scope.row.accountnumber }}
            </template>
          </el-table-column>
          <el-table-column prop="sortcode" label="Sort Code" header-align="center" align="center">
            <template slot-scope="scope">
              {{ isCashAccount(scope.row) ? "" : scope.row.sortcode }}
            </template>
          </el-table-column>
          <el-table-column prop="iban" label="Iban" header-align="center" align="center" width="200"></el-table-column>
          <el-table-column prop="bic" label="Bic" header-align="center" align="center" width="150"></el-table-column>
          <el-table-column prop="type" label="Type" header-align="center" align="center"></el-table-column>
          <el-table-column prop="purpose" label="Purpose" header-align="center" align="center" width="100"></el-table-column>
          <el-table-column prop="status" label="Status" header-align="center" align="center" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 'active'" type="success" size="small">{{ scope.row.status }}</el-tag>
              <el-tag v-if="scope.row.status === 'closed'" type="danger" size="small">{{ scope.row.status }}</el-tag>
              <el-tag v-if="scope.row.status === 'suspended'" type="info" size="small">{{ scope.row.status }}</el-tag>
              
            </template>
          </el-table-column>
          <el-table-column prop="created_date" label="Created" header-align="center" align="center" width="150"></el-table-column>
          <el-table-column prop="updated_date" label="Updated" header-align="center" align="center" width="150"></el-table-column>
          <el-table-column prop="Id" label="Action" header-align="center" align="center" width="100" fixed="right">
            <template slot-scope="scope">
              
              <div v-if="scope.row.bankholderID">
                <el-button icon="el-icon-circle-check" type="primary" size="mini" @click="$router.push(`/bank-account/view/customer/${scope.row.bankholderID}`)">View</el-button>
              </div>
            </template>
          </el-table-column>

        </el-table>
    </el-card>
  </div>
</template>

<script>
import { findObjectArray, isCashAccount, accountTypeLabel, bankAccountName } from '@/utils'
import { bankSearch } from '@/api/bank-account'
export default {
  data(){
    return {
      search_by : "membercode",
      search_value: "",
      tableData: [],
      dataTableSelect: [],
      loading: false,
      btnActive: {
        all: true,
        active: true,
        suspended: true,
        closed: true
      },
      count:{
        all: 0,
        active: 0,
        suspended: 0,
        closed: 0
      }
    }
  },
  watch: {
    $route(from, to) {
      this.search();
    },
  },
  methods:{
    isCashAccount,
    accountTypeLabel,
    bankAccountName,

    search(){
      let formData = {
        search_by : this.$route.query.search_by,
        search_value: this.$route.query.search_value
      }
      this.loading = true
      bankSearch(formData).then(({result, data}) =>{
        this.loading = false
        if(result){
          this.tableData = data
          this.getDataSelect('active');
          this.setCounting()
        }
      })
    },
    
    resetActiveBtn(){
      this.btnActive.all = true
      this.btnActive.active = true
      this.btnActive.suspended = true
      this.btnActive.closed = true
    },

    setCounting(){
      this.count.all = this.tableData.length
      this.count.active = findObjectArray(this.tableData, "active", "status").length
      this.count.suspended = findObjectArray(this.tableData, "suspended", "status").length
      this.count.closed = findObjectArray(this.tableData, "closed", "status").length
    },

    getDataSelect(select){
      this.resetActiveBtn()
      this.btnActive[select] = false
      if(select){
        this.dataTableSelect = findObjectArray(this.tableData, select, "status")
      }else{
        this.dataTableSelect = this.tableData
      }
    },
  },
  created(){
    this.search();
  }
};
</script>

<style lang="scss">
.search-bank-container {
  .el-select .el-input {
    width: 130px;
  }
  .el-input__inner::placeholder {
    color: #fff;
  }
  .el-input-group__append button.el-button,
  .el-input-group__append div.el-select .el-input__inner,
  .el-input-group__append div.el-select:hover .el-input__inner,
  .el-input-group__prepend button.el-button,
  .el-input-group__prepend div.el-select .el-input__inner,
  .el-input-group__prepend div.el-select:hover .el-input__inner {
    border-color: #409eff;
    background-color: #409eff;
    color: #fff;
    border-top: 0;
    border-bottom: 0;
    border-radius: 0;
  }

  .el-select .el-input .el-select__caret {
    color: #fff;
  }

  .btn-status{
    margin-bottom: 10px;
  }

  .item {
    margin-right: 20px;
  }
}
</style>